<template>
  <div class="MembershipRoster wow bounceInUp">
    <div class="cont">
      <ComTitlte
        class="c_title"
        titleEn="MEMBER NAME"
        titleZh="会员名册"
      ></ComTitlte>
      <div class="main">
        <!-- <div class="memberList">
          <div class="m_item" v-for="item in NotMemberList" :key="item.id">
            <div class="m_title">{{ item.lable }}</div>
            <div class="lable_list">
              <div class="c_item" v-for="a in item.arr" :key="a.id">
                {{ a.lable }}
              </div>
            </div>
          </div>
          <div class="m_item" v-if="MemberInfoList.length > 0">
            <div class="m_title">会员</div>
            <div class="lable_list">
              <div class="c_item" v-for="item in MemberInfoList" :key="item.id">
                {{ item.enterpriseName }}
              </div>
            </div>
            <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                :hide-on-single-page="MemberInfoList.length <= PageSize"
                :page-size="PageSize"
                :total="Total"
                @size-change="getPage"
                @current-change="getPage"
              >
              </el-pagination>
            </div>
          </div>
        </div> -->
        <div class="memberList">
          <div class="m_item" v-for="item in MemberList" :key="item.key">
            <div class="m_title">{{ item.lable }}</div>
            <div class="lable_list">
              <div class="c_item" v-for="a in item.arr" :key="a.key">
                {{ a.lable }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "MembershipRoster",
  data() {
    return {
      MemberList: [
        {
          key: "huizhang",
          lable: "会长",
          arr: [
            {
              key: "0-1",
              lable: "广州工业投资控股集团有限公司",
            },
          ],
        },
        {
          key: "changwufuhuizhang",
          lable: "常务副会长",
          arr: [
            {
              key: "1-1",
              lable: "广州化工交易中心有限公司",
            },
          ],
        },
        {
          key: "fuhuizhang",
          lable: "副会长",
          arr: [
            {
              key: "2-1",
              lable: "广东南方碱业股份有限公司",
            },
            {
              key: "2-2",
              lable: "广州集泰化工股份有限公司",
            },
            {
              key: "2-3",
              lable: "金发科技股份有限公司",
            },
          ],
        },
        {
          key: "jianshizhang",
          lable: "监事长",
          arr: [
            {
              key: "3-1",
              lable: "广州应急管理培训中心有限公司",
            },
          ],
        },
        {
          key: "jianshi",
          lable: "监事",
          arr: [
            {
              key: "4-1",
              lable: "广州赫尔普化工有限公司",
            },
            {
              key: "4-2",
              lable: "广州秀珀化工涂料有限公司",
            },
          ],
        },
        {
          key: "lishi",
          lable: "理事",
          arr: [
            {
              key: "5-1",
              lable: "呈和科技股份有限公司",
            },
            {
              key: "5-2",
              lable: "广东博兴新材料科技有限公司",
            },
            {
              key: "5-3",
              lable: "广东珠江化工涂料有限公司",
            },
            {
              key: "5-4",
              lable: "广州广钢气体能源股份有限公司",
            },
            {
              key: "5-5",
              lable: "广州华立颜料化工有限公司",
            },
            {
              key: "5-6",
              lable: "广州化工研究设计院",
            },
            {
              key: "5-7",
              lable: "广州化学试剂厂",
            },
            {
              key: "5-8",
              lable: "广州吉必盛科技实业有限公司",
            },
            {
              key: "5-9",
              lable: "广州巨元生化有限公司",
            },
            {
              key: "5-10",
              lable: "广州市白云化工实业有限公司",
            },
            {
              key: "5-11",
              lable: "广州市炳杰贸易有限公司",
            },
            {
              key: "5-12",
              lable: "广州市东泰化工有限公司",
            },
            {
              key: "5-13",
              lable: "广州市方川润滑科技有限公司",
            },
            {
              key: "5-14",
              lable: "广州市高士实业有限公司",
            },
            {
              key: "5-15",
              lable: "广州市国际工程咨询公司",
            },
            {
              key: "5-16",
              lable: "广州市途胜物流有限公司",
            },
            {
              key: "5-17",
              lable: "广州市五羊油漆（翁源）有限公司",
            },
            {
              key: "5-18",
              lable: "广州市祥熙贸易有限公司",
            },
            {
              key: "5-19",
              lable: "广州市振兴实业有限公司",
            },
            {
              key: "5-20",
              lable: "广州天赐高新材料股份有限公司",
            },
            {
              key: "5-21",
              lable: "广州星亚高新塑料科技股份有限公司",
            },
            {
              key: "5-22",
              lable: "广州中滔绿由环保科技有限公司",
            },
          ],
        },
        {
          key: "huiyuan",
          lable: "会员",
          arr: [
            {
              lable: "广东道迩孚实业有限公司",
              key: "6-0",
            },
            {
              lable: "广东东南科创科技有限公司",
              key: "6-1",
            },
            {
              lable: "广东国规检测检验中心有限公司",
              key: "6-2",
            },
            {
              lable: "广东美众联网络科技有限公司",
              key: "6-3",
            },
            {
              lable: "广东省工业气体行业协会",
              key: "6-4",
            },
            {
              lable: "广东维新建设有限公司",
              key: "6-5",
            },
            {
              lable: "广东裕方建设工程有限公司",
              key: "6-6",
            },
            {
              lable: "广东中科天元新能源科技有限公司",
              key: "6-7",
            },
            {
              lable: "广州保赐利化工有限公司",
              key: "6-8",
            },
            {
              lable: "广州博诺通技术股份有限公司",
              key: "6-9",
            },
            {
              lable: "广州达雅化工有限公司",
              key: "6-10",
            },
            {
              lable: "广州福诚美化工有限公司",
              key: "6-11",
            },
            {
              lable: "广州冠融富泰化工有限公司",
              key: "6-12",
            },
            {
              lable: "广州合致信息科技有限公司",
              key: "6-13",
            },
            {
              lable: "广州华南新材料创新园有限公司",
              key: "6-14",
            },
            {
              lable: "广州化工设计工程有限公司",
              key: "6-15",
            },
            {
              lable: "广州汇富研究院有限公司",
              key: "6-16",
            },
            {
              lable: "广州精码化工有限公司",
              key: "6-17",
            },
            {
              lable: "广州精细化学工业公司",
              key: "6-18",
            },
            {
              lable: "广州巨邦环保工程设备有限公司",
              key: "6-19",
            },
            {
              lable: "广州开发区化工行业协会",
              key: "6-20",
            },
            {
              lable: "广州力盟树脂有限公司",
              key: "6-21",
            },
            {
              lable: "广州立邦涂料有限公司",
              key: "6-22",
            },
            {
              lable: "广州励宝新材料科技有限公司",
              key: "6-23",
            },
            {
              lable: "广州鹿山新材料股份有限公司",
              key: "6-24",
            },
            {
              lable: "广州南沙龙沙有限公司",
              key: "6-25",
            },
            {
              lable: "广州尼科精细化工有限公司",
              key: "6-26",
            },
            {
              lable: "广州石化建筑安装工程有限公司",
              key: "6-27",
            },
            {
              lable: "广州市爱宕科学仪器有限公司",
              key: "6-28",
            },
            {
              lable: "广州市标榜汽车用品实业有限公司",
              key: "6-29",
            },
            {
              lable: "广州市博之源化学有限公司",
              key: "6-30",
            },
            {
              lable: "广州市渤源石油化工有限公司",
              key: "6-31",
            },
            {
              lable: "广州市浩盈化工科技有限公司",
              key: "6-32",
            },
            {
              lable: "广州市集华精细化工有限公司",
              key: "6-33",
            },
            {
              lable: "广州市杰布化工有限公司",
              key: "6-34",
            },
            {
              lable: "广州市浪奇实业股份有限公司",
              key: "6-35",
            },
            {
              lable: "广州市盟鸿机械工业有限公司 ",
              key: "6-36",
            },
            {
              lable: "广州市民渝自动化设备有限公司",
              key: "6-37",
            },
            {
              lable: "广州市台实防水补强有限公司",
              key: "6-38",
            },
            {
              lable: "广州市泰力高复合材料有限公司",
              key: "6-39",
            },
            {
              lable: "广州市威格林环保科技有限公司",
              key: "6-40",
            },
            {
              lable: "广州市先万化工有限公司",
              key: "6-41",
            },
            {
              lable: "广州市享美化工科技有限公司",
              key: "6-42",
            },
            {
              lable: "广州市鑫盐丰化工贸易有限公司",
              key: "6-43",
            },
            {
              lable: "广州市粤佳气体有限公司",
              key: "6-44",
            },
            {
              lable: "广州市长安粘胶制造有限公司",
              key: "6-45",
            },
            {
              lable: "广州双塑新材料有限公司",
              key: "6-46",
            },
            {
              lable: "广州双一乳胶制品有限公司",
              key: "6-47",
            },
            {
              lable: "广州天朗涂料化工有限公司",
              key: "6-48",
            },
            {
              lable: "广州砼友新材料科技有限公司",
              key: "6-49",
            },
            {
              lable: "广州万力涂料有限公司",
              key: "6-50",
            },
            {
              lable: "广州盈栢化工科技有限公司",
              key: "6-51",
            },
            {
              lable: "宏昌电子材料股份有限公司",
              key: "6-52",
            },
            {
              lable: "绿色链（广东）检测科技有限公司",
              key: "6-53",
            },
            {
              lable: "上海中硕国际物流有限公司广州分公司",
              key: "6-54",
            },
            {
              lable: "天津膜天膜科技股份有限公司广州分公司",
              key: "6-55",
            },
            {
              lable: "万力轮胎股份有限公司",
              key: "6-56",
            },
            {
              lable: "中粤唐虞科技有限公司",
              key: "6-57",
            },
            {
              lable: "珠海砺锋化学有限公司",
              key: "6-58",
            },
          ],
        },
      ],
      // MemberInfoList: [],
      NotMemberList: [],
      Total: 1, // 总数
      PageNo: 1, // 当前页
      PageSize: 20, // 每页显示条数
      infoDescribe: "6", //会员标识固定传6即可
    };
  },
  created() {
    // 非会员
    // this.getNotMemberEnterprise();
    // 会员
    // this.getMemberEnterprise();
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods: {
    // 组合非会员和企业职务数据格式
    jsonToTree(arr, arrs2) {
      const newArr = [];
      const obj = {};
      arr.map((item) => {
        for (let okey in arrs2) {
          if (item.infoDescribe == okey) {
            let mapObj = {};
            mapObj["key"] = item.infoDescribe;
            mapObj["lable"] = arrs2[okey];
            mapObj["id"] = item.id;
            obj[item.infoDescribe] = mapObj;
            continue;
          }
        }
      });
      arr.forEach((item) => {
        let parent = obj[item.infoDescribe];
        if (parent.key == item.infoDescribe) {
          let forObj = {};
          forObj["key"] = item.infoDescribe;
          forObj["lable"] = item.enterpriseName;
          forObj["id"] = item.enterpriseName;
          (parent.arr || (parent.arr = [])).push(forObj);
        }
      });
      for (let key in obj) {
        newArr.push(obj[key]);
      }
      return newArr;
    },
    getPage(page) {
      // 获取第 page 页数据
      this.PageNo = page;
      this.$nextTick(() => {
        this.getMemberEnterprise();
      });
    },
    // 非会员
    async getNotMemberEnterprise() {
      let res = await this.$request.getNotMemberEnterprise();
      let res2 = await this.$request.getMemberDict();
      let dictData = this.dictData(res2);
      let TreeArr = this.jsonToTree(res, dictData);

      this.NotMemberList = TreeArr;
    },
    // 会员
    async getMemberEnterprise() {
      let _that = this;
      let res = await this.$request.getMemberEnterprise({
        pageNo: this.PageNo,
        pageSize: this.PageSize,
        infoDescribe: this.infoDescribe,
      });
      if (res.code == 200) {
        _that.MemberInfoList = res.rows;
        _that.Total = res.total;
      }
    },
    // 查询职务
    dictData(data) {
      let musterObj = {};
      if (data.length > 0) {
        data.map((item) => {
          musterObj[item.dictValue] = item.dictLabel;
        });
      }
      return musterObj;
    },
  },
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;

.MembershipRoster {
  position: relative;
  padding: 0 0 20px 0;
}

.cont {
  width: $themeMinWidth;
  margin: 40px auto 0;
  position: relative;
  z-index: 6;
  background: #fff;
  box-sizing: border-box;
  padding: 10px 20px 40px 20px;
  border: solid 1px #e3e3e3;

  &::before {
    content: "";
    display: block;
    width: 33px;
    height: 15px;
    background: url("../../assets/img/common/icon_sanjiao.png") top center
      no-repeat;
    background-size: cover;
    position: absolute;
    top: -13px;
    left: 964px;
    z-index: 66;
  }

  .main {
    padding: 40px 0 0 0;

    .memberList {
      position: relative;

      .m_item {
        .m_title {
          font-size: 18px;
          line-height: 30px;
          color: #333333;
          padding: 0 0 0 15px;
          position: relative;

          &::before {
            content: "";
            display: block;
            width: 10px;
            height: 15px;
            background: url("../../assets/img/company/icon_title.png") center
              no-repeat;
            background-size: contain;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(0, -50%);
          }
        }

        .lable_list {
          margin: 20px 0 0 0;
          display: flex;
          flex-flow: wrap;
          flex-direction: row;

          .c_item {
            width: 326px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: #ffffff;
            border: solid 1px #dcdcdc;
            margin: 0 60px 20px 0;

            &:nth-child(3n) {
              margin: 0 0 20px 0;
            }
          }
        }
      }
      .pagination {
        text-align: center;
        padding: 40px 0;
        /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: $themeColor;
        }
      }
    }
  }
}
</style>
